import React from 'react';
import { motion } from 'framer-motion';
import Logo from 'assets/logo.png';
import BackgroundWood from 'assets/background-wood.png';
import { Link } from 'react-router-dom';
import WoodMeetsWonderImage from 'assets/Wood-Meets-Wonder.png';
import { useHomeData } from 'features/misc/api/getHomeData';

export function AuthLayout({ children, title, subtitle }) {
  const fadeIn = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const { data: home, isLoading } = useHomeData();

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-[#FFF6F2] text-gray-800">
      {/* ===== Left Side (Image / Branding) ===== */}
      <div
        className="hidden md:flex md:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage: `url(${home?.data?.footer?.backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-[#AC3F1E]/60 mix-blend-multiply"></div>
        <div className="relative z-10 flex flex-col justify-center items-center text-white text-center px-12">
          <Link to="/">
            <motion.img
              src={home?.data?.navbar?.logo}
              alt="Ayinza Logo"
              className="h-24 w-auto mb-6"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            />
          </Link>
          <motion.img
            src={home?.data?.footer?.imageBelowColumns}
            alt="Wood meets wonder"
            className="h-20 w-auto mb-6"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          />

          <motion.p
            className="text-base max-w-md leading-relaxed"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.2 }}
          >
            Discover handcrafted excellence and sustainable artistry, made in Uganda with purpose
            and passion.
          </motion.p>
        </div>
      </div>

      {/* ===== Right Side (Form) ===== */}
      <div className="w-full md:w-1/2 flex flex-col justify-center items-center px-6 sm:px-12 py-16">
        <motion.div
          className="w-full max-w-md bg-white shadow-lg rounded-lg px-8 py-10"
          variants={fadeIn}
          initial="hidden"
          animate="visible"
        >
          <Link to="/" className="flex justify-center mb-6 md:hidden">
            <img src={home?.data?.navbar?.logo} alt="Ayinza Logo" className="h-16" />
          </Link>

          {/* Page Title */}
          <h1 className="text-2xl font-semibold text-[#AC3F1E] text-center mb-2">{title}</h1>
          {subtitle && <p className="text-sm text-gray-600 text-center mb-8">{subtitle}</p>}

          {/* Auth Form Content */}
          <div>{children}</div>

          {/* Links */}
          <div className="mt-8 text-center text-sm text-gray-600">
            {title === 'Login' ? (
              <>
                Don’t have an account?{' '}
                <Link to="/account/register" className="text-[#AC3F1E] font-medium hover:underline">
                  Register here
                </Link>
              </>
            ) : (
              <>
                Already have an account?{' '}
                <Link to="/account/login" className="text-[#AC3F1E] font-medium hover:underline">
                  Login
                </Link>
              </>
            )}
          </div>
        </motion.div>

        {/* Footer */}
        <div className="mt-8 text-xs text-gray-500 text-center">
          {home?.data?.footer?.footerCopyRightInfo} Built and Maintained by{' '}
          <a href="https://ashita.africa" target="_blank">
            Ashita Creatives
          </a>
        </div>
      </div>
    </div>
  );
}
